import memoize from "lodash/memoize";

import { getColorGenerator } from "./color-generator";

const colors = [
  "#82519A",
  "#F4EB55",
  "#494B99",
  "#E27F66",
  "#F6C658",
  "#3ad48c",
];

const getColor = getColorGenerator(colors);

export const getDealLengthColor = memoize(() => {
  return getColor.next().value;
});
